import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from '@common/models';

export interface IQuestionTypeModel extends IModel {
  questionTypeId: number;
  name: string;
}

export class QuestionTypeModel
  extends Model
  implements ModelRecord<IQuestionTypeModel>
{
  questionTypeId: number;
  name: string;

  constructor(params?: Partial<IQuestionTypeModel>) {
    super(params);
    this.questionTypeId = defaultTo(params?.questionTypeId, 0);
    this.name = defaultTo(params?.name, '');
  }
}
